import { forEach, reduce, map, includes, flatMap } from 'lodash';
import { siblingIdFromName, siblingNameFromId, determineSiblingUsed } from "@/utils/helper.functions";
var ItemPriceModel = /** @class */ (function () {
    function ItemPriceModel(_a) {
        var options = _a.options, freeChoices = _a.freeChoices, _b = _a.itemHasExceptions, itemHasExceptions = _b === void 0 ? false : _b;
        var _this = this;
        this.optionBasePrices = {};
        this.itemHasExceptions = false;
        this.options = options;
        // TODO we will want to abstract this
        // more when an item can have n siblings
        this.initializeTotals();
        this.freeChoices = freeChoices;
        this.itemHasExceptions = itemHasExceptions;
        options.forEach(function (option) {
            _this.optionBasePrices[option.id] = option.basePrice;
        });
    }
    ItemPriceModel.prototype.initializeTotals = function () {
        var _this = this;
        this.totals = {
            whole: {},
            left: {},
            right: {},
        };
        var options = this.options;
        forEach(options, function (option) {
            if (!option.getPriceForSibling) {
                return;
            }
            _this.totals.whole[option.id] = option.getPriceForSibling("0");
            _this.totals.left[option.id] = option.getPriceForSibling("1");
            _this.totals.right[option.id] = option.getPriceForSibling("2");
        });
    };
    ItemPriceModel.prototype.priceWithFreeChoices = function (freeChoices) {
        var totals = this.totals;
        if (freeChoices) {
            totals = freeChoices.assignFreeChoices(totals);
        }
        return totals;
    };
    ItemPriceModel.prototype.mapOptionsWithTotals = function (totals) {
        var options = this.options;
        options = map(options, function (option) {
            var optionId = option.id;
            var choices = option.choices;
            forEach(choices, function (choice) {
                choice.freeChoice = 0;
                forEach(totals, function (total, sibling) {
                    var siblingId = siblingIdFromName(sibling);
                    var totalChoices = total[optionId];
                    forEach(totalChoices, function (totalChoice) {
                        if (totalChoice.id === choice.id) {
                            choice.siblingId = siblingId;
                            choice.freeChoice += totalChoice.free;
                        }
                    });
                });
            });
            return option;
        });
        return options;
    };
    ItemPriceModel.prototype.updateOptions = function () {
        var freeChoices = this.freeChoices;
        var totals = this.priceWithFreeChoices(freeChoices);
        var options = this.mapOptionsWithTotals(totals);
        return options;
    };
    ItemPriceModel.prototype.reduceTotal = function (total) {
        var optionChoices = flatMap(total, function (option, optionId) {
            return option;
        });
        var amount = reduce(optionChoices, function (accumulator, choice) {
            var price = choice.price;
            if (choice.free !== 0 || choice.included || !choice.selected) {
                price = 0;
            }
            return accumulator + price;
        }, 0);
        return amount;
    };
    ItemPriceModel.prototype.getOptionKeysContainingChoices = function (totals) {
        var optionIds = {};
        forEach(totals, function (value, key) {
            for (var key_1 in value) {
                if (value[key_1] && value[key_1].length) {
                    optionIds[key_1] = 1;
                }
            }
        });
        return Object.keys(optionIds);
    };
    ItemPriceModel.prototype.price = function () {
        var _this = this;
        var freeChoices = this.freeChoices;
        var price = 0;
        var totals = this.priceWithFreeChoices(freeChoices);
        var useSibling = determineSiblingUsed(totals);
        // TODO remove sibling specifics
        var siblings = ['whole'];
        var siblingName = siblingNameFromId(useSibling);
        siblings.push(siblingName);
        if (totals) {
            forEach(totals, function (value, key) {
                var amount = _this.reduceTotal(value);
                if (includes(siblings, key)) {
                    price += amount;
                }
            });
        }
        var optionIds = this.getOptionKeysContainingChoices(totals);
        forEach((optionIds), function (optionId) {
            if (_this.optionBasePrices[optionId]) {
                price += _this.optionBasePrices[optionId];
            }
        });
        return price;
    };
    return ItemPriceModel;
}());
export default ItemPriceModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/ItemPriceModel.ts
// module id = /auD
// module chunks = 18